import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import NotificationBadge from 'gcs-common/design-system/ui/notification-badge';
import { friendlyTimeOrDate } from 'gcs-common/helper/dateHelper';
import { getSidebarCollapsed } from 'gcs-common/slices/uiState/uiStateSelectors';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import type { components } from '../../../../types/openapi';
import TicketAttachmentThumbnail from '../TicketAttachmentThumbnail/TicketAttachmentThumbnail';
import TicketStatus from '../TicketStatus/TicketStatus';

interface TicketListItemProps {
  id: string;
  status: components['schemas']['EtsStatusEnum'];
  title: string;
  previewImageUrl: string | undefined;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  hasNotifications: boolean;
}

const TicketListItem = (props: TicketListItemProps) => {
  const { id, status, title, hasNotifications, previewImageUrl = null, updatedAt = undefined } = props;
  const navigate = useNavigate();
  const { routeTicketId } = useParams();
  const ticketId = routeTicketId ?? '';

  const goToTicket = (ticketId: string) => {
    navigate(CHAT_ROUTES.TICKET(ticketId));
  };
  const isSidebarCollapsed = useSelector(getSidebarCollapsed);
  const isActive = ticketId === id;

  return (
    <div
      className={`flex w-full cursor-pointer items-center border-0 border-neutral-3 border-b border-solid py-2 hover:bg-neutral-2 ${
        isSidebarCollapsed ? 'justify-center' : 'justify-between'
      } ${isActive ? 'bg-neutral-3 hover:bg-neutral-3' : ''}`}
      onClick={() => goToTicket(id)}
    >
      <div className="pl-1">
        <NotificationBadge className={`size-[8px] ${hasNotifications ? '' : 'invisible'}`} />
      </div>
      <div className={isSidebarCollapsed ? '' : 'pl-2'}>
        <TicketAttachmentThumbnail thumbnail={previewImageUrl || ''} />
      </div>

      {!isSidebarCollapsed && (
        <>
          <div className="flex-1 overflow-hidden px-3">
            <span className="block w-full truncate text-ellipsis whitespace-nowrap text-base text-neutral-12">
              {title}
            </span>
          </div>
          <div className="flex flex-col items-end pr-4">
            <span className="truncate p-[2px] text-neutral-11 text-sm">{friendlyTimeOrDate(updatedAt)}</span>
            <div className="flex items-center justify-between gap-1">
              <TicketStatus status={status} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TicketListItem;
